// copied from https://github.com/graffer-inc/graffer-schemas/blob/6e9f734e3d7687831d7de1feee7877ef912e9afa/libs/packages/form-schema/lib/utils/date-util.ts#L23

export type JSTDate = {
  yearInJST: number;
  monthInJST: number;
  monthIndexInJST: number;
  dateInJST: number;
  hoursInJST: number;
  minutesInJST: number;
  secondsInJST: number;
};

const JSTOffset = -540;

/**
 * toJST は、実行環境のタイムゾーンにかかわらず、
 * 受け取った Date Object を解釈し、
 * JST における年月日などを返却します。
 */
export const toJST = (value: Date): JSTDate => {
  // 副作用を抑えるために、新しいオブジェクトを生成する。
  const baseDate = new Date(value.getTime());

  // JSTOffset (-540) と比較した差分を足し引きすることで、
  // 日本時での年月日etcを得られるようにする。
  const offset = baseDate.getTimezoneOffset();
  const minBehind = JSTOffset - offset;
  const millisecBehind = minToMilliseconds(minBehind);
  baseDate.setTime(baseDate.getTime() - millisecBehind);

  return {
    yearInJST: baseDate.getFullYear(),
    monthInJST: baseDate.getMonth() + 1,
    monthIndexInJST: baseDate.getMonth(),
    dateInJST: baseDate.getDate(),
    hoursInJST: baseDate.getHours(),
    minutesInJST: baseDate.getMinutes(),
    secondsInJST: baseDate.getSeconds(),
  };
};

const minToMilliseconds = (min: number): number => {
  return min * 60 * 1000;
};
